import React from 'react';
import { ClockIcon } from '@heroicons/react/24/outline';

interface WaitingRoomProps {
  message?: string;
}

/**
 * Waiting room component shown before session starts
 * Displays while waiting for participants or during connection
 */
export const WaitingRoom: React.FC<WaitingRoomProps> = ({
  message = 'Setting up your session...'
}) => {
  return (
    <div className="flex items-center justify-center h-full bg-gray-900">
      <div className="text-center max-w-md px-6">
        <div className="mb-6">
          <ClockIcon className="w-16 h-16 text-blue-500 mx-auto animate-pulse" />
        </div>
        <h2 className="text-2xl font-bold text-white mb-3">Please Wait</h2>
        <p className="text-gray-300 text-lg mb-6">{message}</p>

        {/* Loading animation */}
        <div className="flex justify-center space-x-2">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="w-3 h-3 bg-blue-500 rounded-full animate-bounce"
              style={{ animationDelay: `${i * 150}ms` }}
            />
          ))}
        </div>

        <div className="mt-8 p-4 bg-gray-800 rounded-lg border border-gray-700">
          <p className="text-sm text-gray-400">
            Make sure your camera and microphone are enabled in your browser settings.
          </p>
        </div>
      </div>
    </div>
  );
};
